import { apiRequest } from './api';
import type { SupportAccessDTO } from '../shared/types';

/**
 * Toplantının destek erişimi (veri koruma programı §4.2/1): kullanıcı açarsa TalkNote
 * destek ekibi o toplantının içeriğini 48 saat boyunca yönetim konsolunda görebilir.
 * Her görüntüleme kayda geçer ve burada ("kim baktı") listelenir. Sunucu ucu:
 * web/app/api/v1/meetings/[id]/support-access/route.ts. Masaüstü ve web aynı modülü kullanır.
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function path(meetingId: string): string {
  if (!UUID.test(meetingId)) throw new Error('Geçersiz toplantı.');
  return `/api/v1/meetings/${meetingId}/support-access`;
}

export function getSupportAccess(meetingId: string): Promise<SupportAccessDTO> {
  return apiRequest<SupportAccessDTO>('GET', path(meetingId));
}

export function setSupportAccess(meetingId: string, enabled: boolean): Promise<SupportAccessDTO> {
  return apiRequest<SupportAccessDTO>(enabled ? 'POST' : 'DELETE', path(meetingId));
}
